import { Injectable, inject } from '@angular/core';
import { SupabaseService } from '../supabase/supabase.service';
import { SupabaseClient } from '@supabase/supabase-js';
import { TenantsService } from '../tenants/tenants.service';

export interface Content {
  file?: string;
  subtitle?: string;
  videos?: VideoContent[];
  audio?: AudioContent[];
  title?: string;
  projectId?: string;
  content?: string;
}

export interface VideoContent {
  file: string;
  sort: number;
  slug: string;
  image: string;
  title: string;
  transcript: string;
}

export interface AudioContent {
  file: string;
  sort: number;
  slug: string;
  image: string;
  title: string;
  transcript: string;
}

export interface Module {
  id: string;
  created_at: string;
  tenant_id: string;
  sort: number;
  type: 'biography' | 'videos' | 'audio' | 'matterport';
  width: number;
  image?: string | null;
  title: string;
  content: Content;
}

@Injectable({
  providedIn: 'root',
})
export class ModulesService {
  private supabase = inject(SupabaseService);
  private tenantService = inject(TenantsService);

  private client: SupabaseClient = this.supabase.client;
  private modules = new Map<string, Module[]>();

  public async getModules(tenant: string | null): Promise<Module[]> {
    if (!tenant) return [];

    if (!this.modules.has(tenant)) {
      const tenantId = this.tenantService.id(tenant);
      const modules = (
        await this.client.from('modules').select('*').eq('tenant_id', tenantId)
      ).data as Module[];
      this.modules.set(tenant, modules);
      return modules;
    }

    return this.modules.get(tenant) || [];
  }

  public async getModuleByType(
    tenant: string | null,
    type: string,
  ): Promise<Module> {
    return (await this.getModules(tenant)).filter((e) => e.type === type)[0];
  }
}
